// Backend Service API calls
import axios from "axios";

let API_BASE_URL = import.meta.env.VITE_API_URL || "/api/v1";

// Main API client for backend services
export const apiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access

      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export const regionAPI = {
  // Region API calls
  getRegions: (params = {}) => {
    return apiClient.get("/regions/", { params });
  },
  createRegion: (regionData) => {
    return apiClient.post("/regions/", regionData);
  },
  getRegion: (id) => {
    return apiClient.get(`/regions/${id}`);
  },
  updateRegion: (id, regionData) => {
    return apiClient.put(`/regions/${id}`, regionData);
  },
  deleteRegion: (id) => {
    return apiClient.delete(`/regions/${id}`);
  },
};
